import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar';
import { DocContentImage, DocInlineImage, DocModalImage, DocSidebarImage } from '../component/DocMedia';
import SettingsMenuOverview from './SettingsMenuOverview';
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function Teams() {
    const { t } = useTranslation();
    const image001 = useDocImage('teams-img', 'image001.png', 'settings');
    const image002 = useDocImage('teams-img', 'image002.png', 'settings');
    const image003 = useDocImage('teams-img', 'image003.png', 'settings');
    const image004 = useDocImage('teams-img', 'image004.png', 'settings');
    const image005 = useDocImage('teams-img', 'image005.png', 'settings');
    const image006 = useDocImage('teams-img', 'image006.png', 'settings');
    const image007 = useDocImage('teams-img', 'image007.png', 'settings');

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>

                            <h1 className='mt-0 text-primary'>{t('documentation.teams.title')}</h1>
                            <p className='header-para mb-10'>{t('documentation.teams.introLine1')}</p>
                            <p className='header-para mb-10'>{t('documentation.teams.introLine2')}</p>
                            <p className='header-para'>{t('documentation.teams.introLine3')}</p>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.teams.accessing.title')}
                                </div>
                                <div className="card-body">
                                    <p>{t('documentation.teams.accessing.intro')}</p>
                                    <SettingsMenuOverview />
                                    <ul>
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.teams.accessing.steps.step1') }} />
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.teams.accessing.steps.step2') }} />
                                    </ul>
                                    <DocSidebarImage src={image001} alt={t('documentation.teams.accessing.imageAlt')} />
                                    <ul className="mb-0">
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.teams.accessing.steps.step3') }} />
                                    </ul>
                                    <p><b>{t('documentation.teams.search.title')}</b></p>
                                    <DocInlineImage src={image002} alt={t('documentation.teams.search.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.teams.search.steps.step1')}</li>
                                        <li>{t('documentation.teams.search.steps.step2')}</li>
                                    </ul>

                                    <p><b>{t('documentation.teams.sort.title')}</b></p>
                                    <DocInlineImage src={image003} alt={t('documentation.teams.sort.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.teams.sort.steps.step1')}</li>
                                       <li>{t('documentation.teams.sort.steps.step2')}</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.teams.listOverview.title')}
                                </div>
                                <div className="card-body">
                                    <p>{t('documentation.teams.listOverview.intro')}</p>
                                    <DocContentImage src={image004} alt={t('documentation.teams.listOverview.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.teams.listOverview.columns.teamName')}</li>
                                        <li>{t('documentation.teams.listOverview.columns.member')}</li>
                                        <li>{t('documentation.teams.listOverview.columns.actions')}</li>
                                    </ul>

                                    <p><b>{t('documentation.teams.editing.title')}</b> {t('documentation.teams.editing.intro')}</p>

                                    <ul>
                                        <DocContentImage src={image005} alt={t('documentation.teams.editing.imageAlt')} />
                                        <li>{t('documentation.teams.editing.steps.step1')}</li>
                                        <li>
                                            {t('documentation.teams.editing.steps.step2')}
                                            <ul className='pt-10'>
                                                <li>{t('documentation.teams.editing.steps.step3')}</li>
                                                <li>{t('documentation.teams.editing.steps.step4')}</li>
                                                <li>{t('documentation.teams.editing.steps.step5')}</li>
                                            </ul>
                                        </li>
                                        <li>
                                            {t('documentation.teams.editing.steps.step6')}
                                            <ul className='pt-10'>
                                                <li>{t('documentation.teams.editing.steps.step7')}</li>
                                                <li>{t('documentation.teams.editing.steps.step8')}</li>
                                                <li>{t('documentation.teams.editing.steps.step9')}</li>
                                                <li>{t('documentation.teams.editing.steps.step10')}</li>
                                            </ul>
                                        </li>
                                        <li>
                                            {t('documentation.teams.editing.steps.step11')}
                                            <ul className='pt-10 pb-10'>
                                                <li>{t('documentation.teams.editing.steps.step12')}</li>
                                                <li>{t('documentation.teams.editing.steps.step13')}</li>
                                                <li>{t('documentation.teams.editing.steps.step14')}</li>
                                            </ul>
                                        </li>
                                        {t('documentation.teams.editing.steps.step15')}
                                    </ul>

                                    <p><b>{t('documentation.teams.deleting.title')}</b></p>
                                    <ul>
                                        <DocModalImage src={image006} alt={t('documentation.teams.deleting.imageAlt')} />
                                        <li>{t('documentation.teams.deleting.steps.step1')}</li>
                                        <li>{t('documentation.teams.deleting.steps.step2')}</li>
                                        <li>{t('documentation.teams.deleting.steps.step3')}</li>
                                    </ul>

                                    <p><b>{t('documentation.teams.manageMembers.title')}</b></p>
                                    <ul>
                                        <li>{t('documentation.teams.manageMembers.steps.step1')}</li>
                                    </ul>

                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.teams.addTeam.title')}
                                </div>
                                <div className="card-body">

                                    <ul>

                                        <li>{t('documentation.teams.addTeam.steps.step1')}</li>
                                        <li>{t('documentation.teams.addTeam.steps.step2')}</li>
                                        <li>{t('documentation.teams.addTeam.steps.step3')}</li>
                                        <DocContentImage src={image007} alt={t('documentation.teams.addTeam.imageAlt')} />

                                        
                                    </ul>



                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
